import React from 'react';
import Paper from '@material-ui/core/Paper';

import {prepareUsageHistoryChartData} from '../../../../helpers/UsageDashboardHelper';
import {displayCost, displayUsage} from '../../../../helpers/helper';
import {NA_FALLBACK_TEXT } from '../../../../constants/common';
import BCLHighchart from '../../../common/Highchart/BCLHighchart';
import { Configuration } from '../../../../configs/Configuration';
import { USAGE_TYPE } from '../../../../constants/common';

const getOptions = (data, naText, configColors, configs) => {
    const options = {
        chart: {
            type: 'column',
            style: {
              textShadow: 'none',
              color: `rgb(${configColors['--color_36']})`
            }
        },
        xAxis : {
          categories: data.xAxisData,
          gridLineDashStyle: "shortdash",
          gridLineWidth: 1,
          labels: {
            rotation: -90,
            style: {
              fontSize: '15px',
              lineHeight: '22px',
              color: `rgb(${configColors['--color_36']})`
            }
          }
        },
        yAxis: {
            title: {
                text: ''
            },
            labels: {
              step: 2,
              style: {
                fontSize: '12px',
                lineHeight: '22px',
                color: `rgb(${configColors['--color_36']})`
              },
              formatter: function() {
                return (configs.data["usageHistoryWidget.displayValue"] === USAGE_TYPE.COST ? displayCost({cost:this.value, showCurrency:true}) : displayUsage({usage:this.value, showUsageUnit: true , fuelType: configs.data.fuelType}));
              }
            },
            gridLineDashStyle: 'shortdash'
        },
        tooltip: {
            formatter: function() {
              return (this.y ? (configs.data["usageHistoryWidget.displayValue"] === USAGE_TYPE.COST ? displayCost({cost:this.y, showCurrency:true}) : displayUsage({usage:this.y, showUsageUnit:true, fuelType: configs.data.fuelType})) : false)
            }
        },
        series: [{
          showInLegend: false,
          data: data.yAxisData,
          dataLabels: {
            enabled : true,
            formatter : function(){
              if(!this.y){
                return `<span style="color: rgb(${configColors['--color_2']});font-size:13px;">${naText}</span>`;
              }
            }
          }
        }],
      colors: [`rgb(${configColors['--color_1']})`]
    }
  return options;
}

class UsageHistory extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      seriesData : null
    }
    this.configColors = Configuration.getColors().colors;
  }

  componentDidMount() {
    let data = prepareUsageHistoryChartData(this.props.chartData, this.props.configs.data["usageHistoryWidget.displayValue"]);
    let options = getOptions(data, this.props.translations.data["COMMON.NA_TEXT"] || NA_FALLBACK_TEXT, this.configColors, this.props.configs);
    this.setState({
      seriesData : options
    })
  }

  render(){
    return(
      <Paper className="usage-history-container">
        <div className="usage-header-container">
          <div className="usage-header">
            Usage History
          </div>
        </div>
        <div className="usage-chart-container">
          <BCLHighchart
             options={this.state.seriesData}
             ref={"chartComponent"}
           />
        </div>
        {this.props.chartData.length === 0 && (
          <div className="home-api-error">{this.props.translations.data["HOME.USAGE_HISTORY.API_ERROR"]}</div>
        )}
      </Paper>
    );
  }
}

export default UsageHistory;
